var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.566 14.495c-.198.198-.297.297-.412.334a.5.5 0 0 1-.309 0c-.114-.037-.213-.136-.41-.334L7.47 10.53c-.165-.164-.247-.247-.286-.339a.5.5 0 0 1 0-.382c.039-.092.12-.175.286-.34.164-.164.247-.246.339-.284a.5.5 0 0 1 .382 0c.092.038.175.12.34.285l3.186 3.186c.1.1.149.149.206.168a.25.25 0 0 0 .154 0c.057-.019.107-.069.206-.168L15.47 9.47c.164-.165.247-.247.339-.285a.5.5 0 0 1 .382 0c.092.038.175.12.34.285.164.164.246.247.285.339a.5.5 0 0 1 0 .382c-.039.092-.121.175-.286.34l-3.964 3.964Z"
  })));
};
export default SvgChevronDown;